import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';
import { DEFAULT_TIMESPAN } from './utils/timespan.js';

const initialState = {
  filters: {
    timespan: DEFAULT_TIMESPAN,
    teamIds: {},
    studentIds: {},
    productIds: {}
  },
  query: ""
};
const slice = createSlice({
  name: "user-area/component-entries",
  initialState,
  reducers: {
    filterByTimespan(state, action) {
      state.filters.timespan = action.payload;
    },
    filterByTeam(state, action) {
      if (state.filters.teamIds[action.payload]) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete state.filters.teamIds[action.payload];
      } else {
        state.filters.teamIds[action.payload] = true;
      }
    },
    filterByStudent(state, action) {
      if (state.filters.studentIds[action.payload]) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete state.filters.studentIds[action.payload];
      } else {
        state.filters.studentIds[action.payload] = true;
      }
    },
    filterByProduct(state, action) {
      if (state.filters.productIds[action.payload]) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete state.filters.productIds[action.payload];
      } else {
        state.filters.productIds[action.payload] = true;
      }
    },
    setQuery(state, action) {
      state.query = action.payload;
    },
    reset(state) {
      state.filters = initialState.filters;
      state.query = initialState.query;
    }
  }
});
const store = createIndependentStore(slice);
const componentEntryStore = store;
const useComponentEntrySelector = store.useSelector;

export { componentEntryStore, useComponentEntrySelector };
//# sourceMappingURL=state.js.map
